import searchPeriodsFixedTableComponents from "./table/module";
import FilterBarFixed from "./filter-bar-fixed";
import DateNav from "./date-nav";

const modul = angular
    .module("searchPeriodsFixedComponents", [searchPeriodsFixedTableComponents])

    .directive("filterBarFixed", FilterBarFixed)

    .directive("dateNav", DateNav);

export default modul.name;
